import moment from "moment";
import { GET_FILE_MONITORING_TABLE, GET_FILE_MONITORING_TABLE_V1 } from "../../api";
import axiosInstance from "../../axiosInstance";
import { converToStrDateForAPI, converToStrDateTimeForAPI } from "../../components/DashBoard/Dashboard/functions";
import { GET_SYNCHRONIZATION_MONITOR_FILE_NAMES, SYNCHRONIZATION_MONITOR } from "../../routeNames";
import { EXCEPTION_RECORDS } from "../../routeNames";


export const getFileMonitoringTable = (page,limit, search ,isExport =false ,header_names) => onResponse => {
    try {
        // let base_uri = `${SFTP_CLIENT_LIST_URL}?`
        const transformedSearch = Object.fromEntries(
            Object.entries(search || {}).map(([key, value]) => {

                if (key === 'created_date_range') {
                    return [key, converToStrDateForAPI(value)];
                }
                const arrayProp = ['facility','client','partner']
                if( Array.isArray(value) && arrayProp?.includes(key)){
                     return [key, value?.join(',')]
                }
                if( Array.isArray(value) && key==='zero_filter_type'){
                     return [key, value?.map(i=>i.value)?.join(',')]
                }
                 return [key, value];
            })
        );
        axiosInstance.get(GET_FILE_MONITORING_TABLE_V1, {
            params: {
                page,limit,
                ...transformedSearch,
                 ...(isExport && { export: true ,header_names:header_names}),
            },
        })
            // axiosInstance.get(SFTP_CLIENT_LIST_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
        
    }
};



export const getretrivesyncmonitor =
  (page, limit, search, isExport = false, header_names) =>
  (onResponse) => {
    try {

      const transformedSearch = Object.fromEntries(
        Object.entries(search || {}).flatMap(([key, value]) => {

     
        

          if (key === "range_start" || key === "range_end") {
            if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
                return [[key, converToStrDateTimeForAPI(value)]];
            }
          }

          if (value === null || value === undefined || value === "") {
            return [];
          }
          if(key==='partner'){
            return [["partners", value.join(",")]];
          }

          if (Array.isArray(value)) {
            if (value.length === 0) return [];
            return [[key, value.join(",")]];
          }
         

          return [[key, value]];
        })
      );

      axiosInstance.get(SYNCHRONIZATION_MONITOR, {
        params: {
          page,
          limit,
          ...transformedSearch,
          ...(isExport && { export: true, header_names }),
        },
      })
      .then(res => onResponse(res.data))
      .catch(err => onResponse(err));

    } catch (error) {
      console.log(error);
    }
  };

export const getSyncMonitorFiles = 
  (page, limit, search) => 
  (onResponse) => {
    try {
        const transformedSearch = Object.fromEntries(
            Object.entries(search || {}).map(([key, value]) => {
                if (key === 'status' && (value === 'synced' || value === 'not_synced')) {
                    return [key, value === 'synced' ? true : false];
                }
                if(key ==='filename'){
                    return [key, value.trim()];
                }
                return [key, value];
            })
        );

        axiosInstance.get(GET_SYNCHRONIZATION_MONITOR_FILE_NAMES, {
            params: {
                page,
                limit,
                ...transformedSearch
            },
        })
        .then(res => onResponse(res.data))
        .catch(err => onResponse(err));
    } catch (error) {
        console.log(error);
    }
};




export const getExceptionRecordTable = (page,limit, search ,isExport =false ,header_names) => onResponse => {
    try {
     
        const transformedSearch = Object.fromEntries(
             Object.entries(search || {}).flatMap(([key, value]) => {


    if (key === "created_date" && value?.length > 0) {
      return [[
        "created_date_range",
        `${moment(value[0]).format("MM/DD/YYYY HH:mm:ss")} - ${moment(value[1]).format("MM/DD/YYYY HH:mm:ss")}`
      ]];
    }

    
    if (!value || value.length === 0) return [];

    
    if (typeof value === 'object' && value !== null && 'value' in value && !Array.isArray(value)) {
        return [[key, value.value]];
    }

    if (Array.isArray(value)) {
        if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null && 'value' in value[0]) {
             return [[key, value.map(item => item.value).join(",")]];
        }
      return [[key, value.join(",")]];
    }

    return [[key, value]];
  })
        );
        axiosInstance.get(EXCEPTION_RECORDS, {
            params: {
                page,limit,
                ...transformedSearch,
                 ...(isExport && { export: true ,header_names:header_names}),
            },
        })
            // axiosInstance.get(SFTP_CLIENT_LIST_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
        
    }
};